import { type BaseResponse } from "@marketplace/shared/types";
import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";

import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseDeleteAutomationMutationParams = {
  options?: UseMutationOptions<
    BaseResponse<undefined>,
    unknown,
    { id: string }
  >;
};

export const useDeleteAutomationMutation = ({
  options
}: UseDeleteAutomationMutationParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) =>
      await AutomationService.deleteAutomation({ payload }),
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: AutomationQueryKeys.getAutomationList._def
      });

      options?.onSuccess?.(...args);
    },
    ...options
  });
};
